import type { NetworkGeneralInfo, NetworkPermissions, Viewer, ViewerId } from './types';

/** Prototype personas. The "write" profile only gets rights through a role listed in « Modifiable par ». */
export const VIEWERS: Record<ViewerId, Viewer> = {
    owner: {
        id: 'owner',
        label: 'Propriétaire',
        user: 'Cecile ONNO',
        roles: ['ON'],
        description: 'Cecile ONNO figure dans « Propriétaire ».',
    },
    write: {
        id: 'write',
        label: 'Écriture',
        user: 'Marc LEROY',
        roles: ['Équipe Études Réseaux'],
        description: 'Marc LEROY appartient au groupe « Équipe Études Réseaux », listé dans « Modifiable par ».',
    },
    read: {
        id: 'read',
        label: 'Lecture',
        user: 'Julie MARTIN',
        roles: ['ON'],
        description: 'Julie MARTIN appartient au groupe « ON », listé uniquement dans « Consultable par ».',
    },
};

export const VIEWER_IDS = Object.keys(VIEWERS) as ViewerId[];

export function isViewerId(value: string | null): value is ViewerId {
    return value !== null && (VIEWER_IDS as string[]).includes(value);
}

/** Mirrors Nemo `casl/ability.ts` for the `users` group (no `managers` persona here). */
export function computePermissions(network: Pick<NetworkGeneralInfo, 'owners' | 'readers' | 'editors' | 'isReference'>, viewer: Viewer): NetworkPermissions {
    const isOwner = network.owners.includes(viewer.user);
    const hasRole = (roles: string[]) => viewer.roles.some((r) => roles.includes(r));
    const canWrite = isOwner || hasRole(network.editors);
    const canRead = canWrite || hasRole(network.readers);
    const canManageAccess = isOwner;
    return {
        canRead,
        canWrite,
        canDelete: canWrite,
        canManageAccess,
        canEdit: !network.isReference && (canWrite || canManageAccess),
    };
}
